import apiClient from '@/services/API'

export default {
  getFilters () {
    return apiClient().get('/filters/')
  },
  getLocations () {
    return apiClient().get('/locations/')
  },
  updateFilters (filters) {
    return apiClient().post('/filters', filters)
  },
  getMe () {
    return apiClient().get('/users/me')
  },
  updateMe (user) {
    return apiClient().put('/users/me', user)
  },
  checkEmail (email) {
    return apiClient().post('/email', email)
  },
  getMemberships () {
    return apiClient().get('/memberships')
  },
  cancelMembership () {
    return apiClient().post('/cancel-membership')
  },
  deleteUser () {
    console.log('UserService deleteUser called');
    return apiClient().delete('/users/me')
  },
  logout () {
    return apiClient().delete('/auth')
  },
  getGeoJson(idString) {
    // if(!idString || idString.length === 0){
    //   return Promise.resolve({
    //     data: {
    //       type: "FeatureCollection",
    //       features: []
    //     }
    //   });
    // }
    return apiClient().get(`/geo/${idString}`)
  },

}
